import { combineReducers } from "redux";
import ProfileReducer from './profile';
import MomentReducer from './moments';
import FeedbackReducer from './feedback';

export default combineReducers({
  'profile': ProfileReducer,
  'moments': MomentReducer,
  'feedback': FeedbackReducer
});